import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";

const servicesData = [
    {
        title: 'WorldWide Tours',
        icon: 'fa-globe',
        description: 'Discover the beauty of the world with our expertly curated international tour packages. From iconic cities to hidden gems, your dream destinations await!',
    },
    {
        title: 'Hotel Reservation',
        icon: 'fa-hotel',
        description: 'Book top-rated hotels at unbeatable prices, anytime and anywhere. Enjoy comfort, convenience, and seamless check-ins on every trip.',
    },
    {
        title: 'Travel Guides',
        icon: 'fa-user',
        description: 'Explore confidently with our expert travel guides by your side. Get insider tips, local secrets, and unforgettable experiences everywhere you go.',
    },
    {
        title: 'Event Management',
        icon: 'fa-cog',
        description: 'From destination weddings to corporate retreats, we plan it all with perfection. Sit back and relax — we’ll turn your event into a memorable celebration!',
    }
];

const ServiceCard = ({ title, image, dec }) => (
    <div className="col-md-6">
        <div className="service-content-inner d-flex align-items-center bg-white border border-primary rounded p-4">
            <div className="service-icon p-2">
                <img src={image} alt="Service" className="img-fluid" style={{ maxWidth: '80px' }} />
            </div>
            <div className="service-content ps-3">
                <h5 className="mb-3">{title}</h5>
                <p className="mb-0">{dec}</p>
            </div>
        </div>
    </div>
);

const Services = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        apiRequest({ url: "/services" })
            .then((res) => {
                if (res.success && Array.isArray(res.data)) {
                    setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);  
            });
    }, []);
    return (
        <div className="container-fluid bg-light service py-5">
            <div className="container py-5">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
                    <h5 className="section-title px-3">Services</h5>
                    <h1 className="mb-0">Our Services</h1>
                </div>
                <div className="row g-4">
                    {data.map((service, idx) => (
                        <ServiceCard key={idx} {...service} />
                    ))}
                    {/* <div className="col-12 text-center">
                        <a className="btn btn-primary rounded-pill py-3 px-5 mt-2" href="#">Service More</a>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Services;
